import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import backk from './images/backk.png';

function Reports() {
  const location = useLocation();
  const navigate = useNavigate();
  const [records, setRecords] = useState([]);
  const [error, setError] = useState(null);

  // Parse query parameters
  const query = new URLSearchParams(location.search);
  const userEmail = query.get('userEmail');
  const fromDate = query.get('fromDate');
  const toDate = query.get('toDate');

  useEffect(() => {
    if (userEmail && fromDate && toDate) {
      fetchData();
    }
  }, [userEmail, fromDate, toDate]);

  const fetchData = async () => {
    try {
      const response = await fetch("https://www.d-rosa.ai/DetailReaddsAPI", {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          TABLE: 'RosaP',
          FIELD: 'Gmail, Checkpoint, Checktime',
          WHERE: `Gmail='${userEmail}' AND Checktime >= '${fromDate}' AND Checktime <= '${toDate}'`,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch records');
      }

      const data = await response.json();

      if (data.error) {
        setError(data.error);
        setRecords([]);
      } else {
        setRecords(data);
        setError(null);
      }
    } catch (error) {
      setError('Error fetching records');
      console.error(error);
    }
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleDownloadPDF = () => {
    const reportElement = document.getElementById('reportTable');

    html2canvas(reportElement, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, 'PNG', 10, 10, imgWidth, imgHeight);
      pdf.save('report.pdf');
    });
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Details for {userEmail}</h2>
      
      {error ? (
        <p style={styles.error}>{error}</p>
      ) : records.length > 0 ? (
        <div id="reportTable" style={styles.tableContainer}>
          <table style={styles.table}>
            <thead>
              <tr style={styles.tableHeader}>
                <th>Gmail</th>
                <th>Checkpoint</th>
                <th>Checktime</th>
              </tr>
            </thead>
            <tbody>
              {records.map((record, index) => (
                <tr key={index}>
                  <td>{record.Gmail}</td>
                  <td>{record.Checkpoint}</td>
                  <td>{record.Checktime}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>No data available for the selected date range.</p>
      )}

      <button onClick={handleDownloadPDF} style={styles.pdfButton}>Get PDF</button>
      <br />
      <br />
      <br />
      <img
        src={backk}
        width="30"
        height="40"
        alt="Back"
        style={styles.backButton}
        onClick={handleBackClick}
      />
    </div>
  );
}

// Styles for mobile responsiveness
const styles = {
  container: {
    background: 'linear-gradient(to bottom, #fff7ad, #ffa9f9)',
    minHeight: '100vh',
    padding: '20px',
    textAlign: 'center',
    boxSizing: 'border-box',
  },
  heading: {
    color: '#E11584',
    fontSize: '1.5em',
    marginBottom: '20px',
  },
  error: {
    color: 'red',
    fontSize: '1.2em',
  },
  tableContainer: {
    overflowX: 'auto',
    maxWidth: '100%',
  },
  table: {
    margin: '0 auto',
    borderCollapse: 'collapse',
    backgroundColor: '#FFD1DC',
    borderColor: '#E11584',
    width: '100%',
    maxWidth: '800px',
  },
  tableHeader: {
    backgroundColor: '#E11584',
    color: '#FFFFFF',
  },
  pdfButton: {
    marginTop: '20px',
    padding: '10px 20px',
    fontSize: '1em',
    color: '#fff',
    backgroundColor: '#E11584',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  backButton: {
    cursor: 'pointer',
    marginTop: '20px',
    maxWidth: '100%',
    height: 'auto',
  },
};

// Responsive styles using media queries
const mediaQueries = `
  @media only screen and (max-width: 600px) {
    .container {
      padding: 10px;
    }

    h2 {
      font-size: 1.5em;
    }

    table {
      width: 100%;
    }

    td {
      font-size: 0.9em;
    }

    img {
      width: 25px;
      height: auto;
    }
  }
`;

const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = mediaQueries;
document.head.appendChild(styleSheet);

export default Reports;
